import { render, staticRenderFns } from "./QuizEmbed.vue?vue&type=template&id=2b24ded8&scoped=true"
import script from "./QuizEmbed.vue?vue&type=script&lang=js"
export * from "./QuizEmbed.vue?vue&type=script&lang=js"
import style0 from "./QuizEmbed.vue?vue&type=style&index=0&id=2b24ded8&prod&lang=scss"
import style1 from "./QuizEmbed.vue?vue&type=style&index=1&id=2b24ded8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24ded8",
  null
  
)

export default component.exports